export const zh = "local_yuan/zh.json";
export const en = "local_yuan/en.json";



// WEBPACK FOOTER //
// ./src/assets/i18n/local_yuan/index.ts